import { type IconProps } from '@/IconsResolver';
import type { IconicNames, IconicTypes } from '@/Iconics.js';
import classnames from 'classnames';
import { useIcon } from '@/hooks/useIcon';

export function Icon<Props = { name: IconicNames; type?: IconicTypes }>(props: IconProps & Props) {
  const icon = useIcon(props.name, props.type);

  if (icon === undefined) {
    return null;
  }

  const {
    component: Component,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    key,
    ...options
  } = icon;

  return (
    <Component {...props} {...options} className={classnames(options.className, props.className)} />
  );
}
